/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>base-menu.component.ts</name>
///
/// <description>

/// </description>
///
/// <author>Michael Martinez</author>
/// <created>14 Oct 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 14Oct16 MM  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///
import {Component, OnInit, Input, Output, SimpleChanges, ViewEncapsulation, EventEmitter } from '@angular/core';


import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';

import {ActivatedRoute, Params } from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import { MenuItem, Message, TreeNode } from 'primeng/primeng';

import {CUIFeatureInterface} from '../../../interfaces/cui-feature.interface';

import {TranslatedStringsService } from '../../../services/language.service';
import {DeviceControlType } from '../../../models/device-data-models/device-control-type.model';
import {DeviceControlActionType } from  '../../../models/device-data-models/device-control-action-type.model';

import {DeviceControlEventModel } from  '../../../models/device-data-models/device-control-event.model';
import {DeviceFormControlModel  } from '../../../models/device-data-models/device-form-control.model';
import {DeviceControlModel } from '../../../models/device-data-models/device-control.model';
import {DeviceCategoryModel } from '../../../models/device-data-models/device-category.model';
import {DeviceCategoryCollectionModel } from '../../../models/device-data-models/device-category-collection.model';
import {CUISingularSettingComponent} from  '../../../shared/cui-singular-setting/cui-singular-setting.component';
import {BaseCommunicationService} from  '../base-communication.service';

import { MediatorService } from '../../../services/mediator.service';
import { MediatorEventLookup } from '../../../services/mediator-event-lookup.service';

@Component({
    selector: 'base-menu',
    templateUrl: './base-menu.component.html'
})
export class BaseMenuComponent   {

    private viewModel: any = null;
    private categories: MenuItem[];
    private getViewModelSubscription: Subscription;
    private selectedNode: TreeNode;

    constructor(
        protected communicationService:BaseCommunicationService,
        protected i18n: TranslatedStringsService,
        private mediator: MediatorService

    ) {





    }
    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {


        //1) Get View Model
        this.getViewModelSubscription = this.communicationService.getViewModel().subscribe(data => {

            if (data && data.length > 0) {
                this.buildPage(data);
            }

        },
        err => {

        });


    }

    //----------------------------------------------------------
    //createNode
    //----------------------------------------------------------
    private createNode(item, index) {

        return {
            id: item.id,
            label: this.i18n.translate(item.id),
            data: item.id,
            icon: 'fa-gears',
            expandedIcon: "fa-folder-open",
            collapsedIcon: "fa-folder",
            leaf: false,
            children: [],
            items: [],
            index: index
        }
    }

    //----------------------------------------------------------
    //buildPage
    //----------------------------------------------------------
    private buildPage(categories) {


        let collection: TreeNode[] = new Array<TreeNode>();

        try {

            let index: number = 0;

            //1) Add top level categories here...
            for (let categoryTop of categories) {

                let Top: any = this.createNode(categoryTop, index);


                //2) Add 2nd level categories here...
                for (let category2nd of categoryTop.categories) {

                    let Second: any = this.createNode(category2nd, index);


                    //3) Add 3rd level categories here...
                    for (let category3rd of category2nd.categories) {

                        let Third: any = this.createNode(category3rd, index);

                            if (Third.label) {
                                Third.leaf = true;
                                Second.items.push(Third);
                            }

                        }

                    if (Second.label) {
                        if (Second.items && Second.items.length > 0) {
                            Second.children = Second.items;
                        }
                        else {
                            Second.leaf = true;
                        }
                        Top.children.push(Second);
                        Top.items.push(Second);
                    }

                }

                if (Top.label) {
                    if (Top.items && Top.items.length > 0) {
                        Top.children = Top.items;
                    }
                    else {
                        Top.leaf = true;
                    }
                    collection.push(Top);
                }

                index++;
            }

            this.categories = collection;

        }
        catch (e) {
            console.log("Error-->buildPage()");
        }


    }

    //----------------------------------------------------------
    //onNodeSelect
    //----------------------------------------------------------
    private onNodeSelect(event) {

        this.mediator.Action(MediatorEventLookup.CategorySelected, this.selectedNode);

    }




}






// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/features/base-component/base-menu/base-menu.component.ts